(() => {
  const root = document;
  let opener;
  let oldOverflow;
  const open = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog || !dialog.showModal || dialog.open) return;
    opener = trigger;
    oldOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (id === 'mh-salon-routine' && !dialog.querySelector('video').getAttribute('src')) dialog.querySelector('[data-mh-video]')?.click();
  };
  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mh-open]');
    if (trigger) { event.preventDefault(); open(trigger.dataset.mhOpen, trigger); }
    const closer = event.target.closest('[data-mh-close]');
    if (closer) closer.closest('dialog')?.close();
    const source = event.target.closest('[data-mh-video]');
    if (source) {
      const dialog = source.closest('dialog');
      const video = dialog.querySelector('video');
      video.pause();
      video.poster = source.dataset.mhPoster;
      dialog.querySelector('[data-mh-routine-product]').href = source.dataset.mhProductUrl;
      video.src = source.dataset.mhVideo;
      dialog.querySelector('.mh-routine-steps').textContent = source.dataset.mhSteps;
      video.load();
      dialog.querySelectorAll('[data-mh-video]').forEach(button => button.setAttribute('aria-pressed', String(button === source)));
    }
  });
  document.querySelectorAll('.mh-salon-dialog').forEach(dialog => {
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => { dialog.querySelectorAll('video').forEach(video => video.pause()); document.documentElement.style.overflow = oldOverflow || ''; opener?.focus({preventScroll:true}); });
    dialog.querySelectorAll('a[href*="#salon"]').forEach(a => a.addEventListener('click', () => dialog.close()));
  });
  const viewport = document.querySelector('.mh-salon-viewport');
  if (viewport) {
    const isMobile = () => window.matchMedia('(max-width:749px)').matches;
    const center = () => { if (isMobile()) viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2; };
    center();
    let resizeTimer;
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(center, 150); });
    document.querySelectorAll('[data-mh-pan]').forEach(button => button.addEventListener('click', () => viewport.scrollBy({left:Number(button.dataset.mhPan) * viewport.clientWidth * .8,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})));
  }
})();


(() => {
 const strip=document.querySelector('.mh-approved-slides');
 if(!strip)return;
 const mobile=matchMedia('(max-width:749px)');
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const buttons=[...document.querySelectorAll('[data-mh-approved-pan]')];
 let selected=1;
 const maxScroll=()=>Math.max(0,strip.scrollWidth-strip.clientWidth);
 const update=()=>{
  const max=maxScroll();
  buttons.forEach(button=>{button.disabled=max<2||(Number(button.dataset.mhApprovedPan)<0?strip.scrollLeft<=2:strip.scrollLeft>=max-2);});
 };
 const go=(index,animate=true)=>{
  selected=Math.max(0,Math.min(2,index));
  strip.scrollTo({left:mobile.matches?maxScroll()*selected/2:0,behavior:animate&&!reduced.matches?'smooth':'instant'});
  update();
 };
 buttons.forEach(button=>button.addEventListener('click',()=>{
  const max=maxScroll();if(max<2)return;
  const current=strip.scrollLeft/(max/2);
  const direction=Number(button.dataset.mhApprovedPan);
  go(direction<0?Math.ceil(current-.02)-1:Math.floor(current+.02)+1);
 }));
 strip.addEventListener('scroll',()=>{const max=maxScroll();if(max>2)selected=Math.round(strip.scrollLeft/(max/2));update();},{passive:true});
 strip.addEventListener('keydown',event=>{
  if(!mobile.matches||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
  event.preventDefault();
  go(event.key==='Home'?0:event.key==='End'?2:selected+(event.key==='ArrowLeft'?-1:1));
 });
 let width=strip.clientWidth;
 new ResizeObserver(()=>{if(strip.clientWidth!==width){width=strip.clientWidth;go(selected,false);}}).observe(strip);
 mobile.addEventListener('change',()=>go(1,false));
 go(1,false);
})();

// Keep the chat launcher compact while preserving its accessible name.
(() => {
  let attempts = 0;
  const compactChat = () => {
    const chat = document.querySelector('shopify-chat');
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('#mh-chat-icon-only')) {
      const style = document.createElement('style');
      style.id = 'mh-chat-icon-only';
      style.textContent = '.activator-nudge{bottom:calc(var(--mh-chat-nav-height,72px) + 16px)!important}.activator__label{display:none!important}.activator{width:48px!important;min-width:48px!important;height:48px!important;padding:0!important;gap:0!important;justify-content:center!important;border-radius:50%!important;background:#000!important;color:#e9b73f!important}.activator__icon{color:#e9b73f!important}';
      root.appendChild(style);
      const nav = document.querySelector('.mh-salon-nav');
      const positionChat = () => {
        const height = nav ? nav.getBoundingClientRect().height : 0;
        runtime.style.setProperty('--mh-chat-nav-height', `${Math.ceil(height)}px`);
      };
      positionChat();
      if (nav) new ResizeObserver(positionChat).observe(nav);
      window.addEventListener('resize', positionChat, { passive: true });
    }
    return true;
  };
  if (!compactChat()) {
    const timer = setInterval(() => { if (compactChat() || ++attempts >= 120) clearInterval(timer); }, 500);
  }
})();

// Product routines: start as soon as the video enters view, including mobile galleries.
(() => {
  if (!location.pathname.includes('/products/')) return;
  const prepare = video => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = true;
    video.preload = 'auto';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
  };
  const start = () => {
    if (document.getElementById('mh-welcome-door')) return false;
    customElements.whenDefined('deferred-media').then(() => {
      const pending = new Map();
      const visible = new Set();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const media = entry.target;
          if (!entry.isIntersecting) {
            visible.delete(media);
            return;
          }
          if (visible.has(media)) return;
          visible.add(media);
          const modal = media.closest('product-modal');
          if (modal && !modal.hasAttribute('open')) return;
          if (pending.has(media)) { pending.get(media)(); return; }
          const templateVideo = media.querySelector('template')?.content.querySelector('video');
          if (templateVideo) prepare(templateVideo);
          // Dawn may have already loaded (and paused) the video on a thumbnail click.
          if (!media.hasAttribute('loaded')) media.loadContent(false);
          const video = media.querySelector('video');
          if (!video) return;
          prepare(video);
          const retry = () => {
            const rect = media.getBoundingClientRect();
            if (document.hidden || rect.bottom <= 0 || rect.top >= innerHeight || rect.right <= 0 || rect.left >= innerWidth) return;
            video.play().catch(() => {});
          };
          const done = () => {
            pending.delete(media);
            video.removeEventListener('canplay', retry);
            video.removeEventListener('loadeddata', retry);
          };
          pending.set(media, retry);
          video.addEventListener('canplay', retry);
          video.addEventListener('loadeddata', retry);
          video.addEventListener('playing', done, { once: true });
          // A deliberate pause must remain effective; never force playback afterward.
          video.addEventListener('pause', () => {
            if (video.currentTime > 0) done();
          }, { once: true });
          retry();
        });
      }, { threshold: 0 });
      document.querySelectorAll('deferred-media').forEach(media => {
        const video = media.querySelector('template')?.content.querySelector('video') || media.querySelector('video');
        if (!video) return;
        prepare(video);
        observer.observe(media);
      });
      // Some mobile browsers require a first gesture even for muted video.
      const retryPending = () => pending.forEach(retry => retry());
      document.addEventListener('touchend', retryPending, { passive: true });
      document.addEventListener('click', retryPending, { passive: true });
      document.addEventListener('visibilitychange', retryPending);
    });
    return true;
  };
  if (!start()) {
    const observer = new MutationObserver(() => { if (start()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
